import { Typography } from "@mui/material";
import React from "react";

interface ShowOrDashProps {
  condition: boolean;
  children: React.ReactNode;
}

const ShowOrDash = ({ condition, children }: ShowOrDashProps): JSX.Element => {
  return (
    <>
      {condition ? (
        children
      ) : (
        <Typography component="span" sx={{ color: "#000 !important", paddingLeft: "0px" }}>
          &ndash;
        </Typography>
      )}
    </>
  );
};

export default ShowOrDash;
